import React from 'react'
import PageHead from '../components/PageHead'
import Container from '../ui/comp/Container'
import { useParams } from 'react-router-dom'
import { useProduct } from '../hooks/useProduct'
import Loading from '../components/Loading'
import NoContent from '../components/NoContent'

function ViewProduct() {

    const { slug } = useParams()

    const { data: product, isLoading, error } = useProduct(slug);


    if (isLoading) {
        return <Loading />
    }

    if (error) {
        return <NoContent />
    }

    return (
        <div className='w-full relative mt-8 space-y-7'>
            <PageHead title={product?.name} />

            {/* Product  */}
            <Container>
                <div className="flex flex-col gap-5 md:flex-row max-w-5xl mx-auto md:p-10 md:gap-7">
                    {/* Image */}
                    <div className="w-full">
                        <div className="relative pt-[100%] overflow-hidden">
                            <img src={`http://localhost:5000/images/${product?.images[0]}`} alt="" className='absolute rounded-xl top-0 left-0 right-0 bottom-0 object-cover w-full h-full' />
                        </div>
                    </div>
                    {/* Contents */}
                    <div className="w-full pt-5">
                        {/* Product name */}
                        <h1>Bamboo Keyholders</h1>
                    </div>
                </div>

                {/* Product */}
            </Container>

        </div>
    )
}

export default ViewProduct


